import React from 'react';
import { useTranslate } from 'react-admin';
import { Box, Typography } from '@mui/material';
import { HelpDialog } from '@/components/shell';

const Topic: React.FC<{ title: string; text: string }> = ({ title, text }) => (
  <Box>
    <Typography variant="subtitle2">{title}</Typography>
    <Typography variant="body2" color="text.secondary">{text}</Typography>
  </Box>
);

/** How the document test works: the capture modes, the options and what each time measures. */
export const TestPageHelp: React.FC<{ open: boolean; onClose: () => void }> = ({ open, onClose }) => {
  const t = useTranslate();
  const h = (key: string) => t(`screens.testPage.help.${key}`);

  return (
    <HelpDialog open={open} onClose={onClose} title={h('title')}>
      <Typography variant="body2">{h('intro')}</Typography>

      <Typography variant="h3" component="h3">{h('modesTitle')}</Typography>
      <Topic title={t('test.single_side')} text={h('single')} />
      <Topic title={t('test.dual_combined')} text={h('dualCombined')} />
      <Topic title={t('test.dual_separate')} text={h('dualSeparate')} />
      <Topic title={t('test.midni')} text={h('midni')} />

      <Typography variant="h3" component="h3">{h('optionsTitle')}</Typography>
      <Topic title={t('test.face')} text={h('face')} />
      <Topic title={t('test.signature')} text={h('signature')} />
      <Topic title={t('test.face_vector')} text={h('faceVector')} />
      <Topic title={t('test.mapping')} text={h('mapping')} />
      <Topic title={t('screens.testPage.debug')} text={h('debug')} />
      <Topic title={t('test.orientation')} text={h('orientation')} />

      <Typography variant="h3" component="h3">{h('timesTitle')}</Typography>
      <Topic title={t('screens.testPage.timeOcr')} text={h('timeOcr')} />
      <Topic title={t('screens.testPage.timeGateway')} text={h('timeGateway')} />
      <Topic title={t('screens.testPage.timeTotal')} text={h('timeTotal')} />
    </HelpDialog>
  );
};
